export const mock_rotate_spin_reulst = {
  tumbles: [
    {
      step: 1,
      combo: 0,
      combo_multiplier_no: 0,
      multiplier: 0,
      win_amount: 0,
      winning_coords: null,
      wild_transforms: null,
      new_board: [
        [
          {
            id: 2,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 2,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 3,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 3,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 4,
            wild_state: 0,
            scatter_value: 0,
          },
        ],
        [
          {
            id: 2,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 1,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 9,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 3,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 8,
            wild_state: 0,
            scatter_value: 0,
          },
        ],
        [
          {
            id: 3,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 4,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 102,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 1,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 5,
            wild_state: 0,
            scatter_value: 0,
          },
        ],
        [
          {
            id: 4,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 1,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 3,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 5,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 6,
            wild_state: 0,
            scatter_value: 0,
          },
        ],
      ],
    },
  ],
  mini_jackpot: null,
  major_jackpot: null,
  grand_jackpot: null,
  total_win: 0,
  win_type: 0,
  hold_spin: null,
}

// rotate
export const mock_spin_result = {
  tumbles: [
    {
      step: 1,
      combo: 1,
      combo_multiplier_no: 0,
      multiplier: 1,
      win_amount: 50000,
      winning_coords: [
        [3, 3],
        [2, 4],
        [1, 0],
        [2, 1],
        [0, 2],
        [2, 2],
      ],
      wild_transforms: [[2, 2]],
      new_board: [
        [
          {
            id: 5,
            wild_state: 1,
            scatter_value: 0,
          },
          {
            id: 8,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 1,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 5,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 1001,
            wild_state: 0,
            scatter_value: 9,
          },
        ],
        [
          {
            id: 1,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 7,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 8,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 2,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 8,
            wild_state: 0,
            scatter_value: 0,
          },
        ],
        [
          {
            id: 103,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 1,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 1,
            wild_state: 1,
            scatter_value: 0,
          },
          {
            id: 102,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 1,
            wild_state: 0,
            scatter_value: 0,
          },
        ],
        [
          {
            id: 4,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 2,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 8,
            wild_state: 1,
            scatter_value: 0,
          },
          {
            id: 1,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 4,
            wild_state: 0,
            scatter_value: 0,
          },
        ],
      ],
    },
    {
      step: 2,
      combo: 2,
      combo_multiplier_no: 1,
      multiplier: 0.3,
      win_amount: 30000,
      winning_coords: [
        [1, 0],
        [1, 1],
        [2, 1],
        [2, 2],
      ],
      wild_transforms: null,
      new_board: [
        [
          {
            id: 5,
            wild_state: 1,
            scatter_value: 0,
          },
          {
            id: 8,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 1,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 5,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 1001,
            wild_state: 0,
            scatter_value: 9,
          },
        ],
        [
          {
            id: 7,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 7,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 8,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 2,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 8,
            wild_state: 0,
            scatter_value: 0,
          },
        ],
        [
          {
            id: 103,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 7,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 1,
            wild_state: 2,
            scatter_value: 0,
          },
          {
            id: 102,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 1,
            wild_state: 1,
            scatter_value: 0,
          },
        ],
        [
          {
            id: 4,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 2,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 8,
            wild_state: 1,
            scatter_value: 0,
          },
          {
            id: 8,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 4,
            wild_state: 0,
            scatter_value: 0,
          },
        ],
      ],
    },
    {
      step: 3,
      combo: 0,
      combo_multiplier_no: 0,
      multiplier: 0,
      win_amount: 0,
      winning_coords: null,
      wild_transforms: null,
      new_board: [
        [
          {
            id: 5,
            wild_state: 1,
            scatter_value: 0,
          },
          {
            id: 8,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 1,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 5,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 1001,
            wild_state: 0,
            scatter_value: 9,
          },
        ],
        [
          {
            id: 103,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 7,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 8,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 2,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 8,
            wild_state: 0,
            scatter_value: 0,
          },
        ],
        [
          {
            id: 103,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 101,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 5,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 102,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 1,
            wild_state: 1,
            scatter_value: 0,
          },
        ],
        [
          {
            id: 4,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 2,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 8,
            wild_state: 1,
            scatter_value: 0,
          },
          {
            id: 8,
            wild_state: 0,
            scatter_value: 0,
          },
          {
            id: 4,
            wild_state: 0,
            scatter_value: 0,
          },
        ],
      ],
    },
  ],
  mini_jackpot: null,
  major_jackpot: null,
  grand_jackpot: null,
  total_win: 80000,
  win_type: 1,
  hold_spin: null,
}
